import React from 'react';
import * as S from './styles';

type Props = {
  title: string;
  onClick?: () => void;
  children?: React.ReactNode;
  showBackArrow?: boolean;
};

export const ListHeader: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<Props>
>> = ({ title, onClick, children, showBackArrow = true }) => {
  return (
    <S.ListHeader>
      <S.MainArea onClick={onClick}>
        <S.LeftArrowArea visible={showBackArrow}>
          <S.LeftArrow />
        </S.LeftArrowArea>
        <S.HeaderTitle>{title}</S.HeaderTitle>
      </S.MainArea>
      <S.ExtraContentArea>{children}</S.ExtraContentArea>
    </S.ListHeader>
  );
};
